<template>
  <el-dialog
    v-model="visible"
    title="宜收宝发票管理中心"
    width="950px"
    destroy-on-close
    @closed="resetData"
    top="5vh"
  >
    <el-tabs
      tab-position="left"
      v-model="activeTab"
      style="height: 550px"
      v-loading="loading"
    >
      <el-tab-pane label="发票基础配置" name="baseConfig">
        <div class="pane-content">
          <div class="pane-header">
            <h3>基础发票参数</h3>
            <span class="desc">管理该商户的基础开票规则和通道参数。</span>
          </div>
          <el-form :model="formData" label-width="140px" class="form-area">
            <el-row>
              <el-col :span="12">
                <el-form-item label="即时开票状态:">
                  <el-switch
                    v-model="formData.enabled"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="启用"
                    inactive-text="停用"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="默认自动开票:">
                  <el-switch
                    v-model="formData.auto_invoice"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="启用"
                    inactive-text="停用"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="开票通道:">
              <el-radio-group v-model="formData.channel">
                <el-radio :label="1">微信</el-radio>
                <el-radio :label="2">支付宝</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="服务商编号:">
              <el-input
                v-model="formData.service_agent_no"
                placeholder="Admin/Agent可手工指定，留空默认推导"
                clearable
              />
            </el-form-item>
            <el-form-item label="子商户号:">
              <el-input
                v-model="formData.sub_mchid"
                placeholder="微信开通必填，支付宝选填"
                clearable
              />
            </el-form-item>
            <el-form-item label="商户税号:">
              <el-input
                v-model="formData.tax_no"
                placeholder="请输入商户税号"
                clearable
              />
            </el-form-item>

            <el-row>
              <el-col :span="12">
                <el-form-item label="开票产品类型:">
                  <el-input
                    v-model="formData.product_id"
                    placeholder="如: 2025060044528616"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开票场景:">
                  <el-select
                    v-model="formData.invoice_scene"
                    placeholder="即时开票场景"
                    filterable
                    allow-create
                    style="width: 100%"
                  >
                    <el-option
                      label="普通发票 (NORMAL_INVOICE)"
                      value="NORMAL_INVOICE"
                    />
                    <el-option
                      label="成品油 (REFINED_OIL_INVOICE)"
                      value="REFINED_OIL_INVOICE"
                    />
                    <el-option
                      label="不动产 (REAL_PROPERTY_BUSINESS_INVOICE)"
                      value="REAL_PROPERTY_BUSINESS_INVOICE"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="默认发票备注:">
              <el-input
                v-model="formData.remark"
                placeholder="最长 200 字"
                maxlength="200"
                clearable
              />
            </el-form-item>
          </el-form>
          <div class="pane-footer">
            <el-button type="primary" @click="saveConfig"
              >保存基础配置</el-button
            >
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="发票行信息" name="invoiceItems">
        <div class="pane-content">
          <div class="pane-header">
            <h3>默认发票明细 (最多 8 条)</h3>
            <span class="desc">配置默认开具的发票商品条目信息。</span>
            <el-button
              type="success"
              plain
              size="small"
              @click="addInvoiceItem"
              :disabled="formData.invoice_items.length >= 8"
              style="float: right"
            >
              + 添加明细
            </el-button>
          </div>

          <div class="form-area">
            <el-table
              :data="formData.invoice_items"
              size="small"
              border
              style="width: 100%"
              height="380"
            >
              <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
              />
              <el-table-column label="终端ID" min-width="120">
                <template #default="{ row }">
                  <el-input
                    v-model="row.terminal_id"
                    size="small"
                    placeholder="请输入终端ID"
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" min-width="120">
                <template #default="{ row }"
                  ><el-input
                    v-model="row.itemName"
                    size="small"
                    placeholder="如: 92#汽油"
                /></template>
              </el-table-column>

              <el-table-column label="规格型号" min-width="100" align="center">
                <template #default="{ row }">
                  <el-input
                    v-model="row.itemSpec"
                    size="small"
                    maxlength="128"
                    placeholder="如: 92#"
                  />
                </template>
              </el-table-column>
              <el-table-column label="单位" width="80" align="center">
                <template #default="{ row }"
                  ><el-input
                    v-model="row.itemUnit"
                    size="small"
                    placeholder="如: 升"
                /></template>
              </el-table-column>
              <el-table-column label="数量" width="70" align="center">
                <template #default="{ row }">
                  <el-input
                    v-model="row.itemNum"
                    size="small"
                    placeholder="数量"
                  />
                </template>
              </el-table-column>

              <el-table-column label="税收分类编码" min-width="140">
                <template #default="{ row }"
                  ><el-input
                    v-model="row.taxCode"
                    size="small"
                    placeholder="19位编码"
                /></template>
              </el-table-column>
              <el-table-column label="税率" width="80">
                <template #default="{ row }"
                  ><el-input
                    v-model="row.itemTaxRate"
                    size="small"
                    placeholder="如: 0.13"
                /></template>
              </el-table-column>
              <el-table-column label="金额/属性" width="150">
                <template #default="{ row }">
                  <el-input
                    v-model="row.invoiceAmount"
                    size="small"
                    placeholder="金额"
                    style="margin-bottom: 5px"
                  />
                  <el-select v-model="row.invoiceLineProperty" size="small">
                    <el-option label="正常商品" value="NORMAL_LINE" />
                    <el-option label="折扣商品" value="DISCOUNT_LINE" />
                    <el-option label="被折扣商品" value="DISCOUNTED_LINE" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="60"
                align="center"
                fixed="right"
              >
                <template #default="{ $index }">
                  <el-button
                    type="danger"
                    link
                    @click="removeInvoiceItem($index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pane-footer">
            <el-button type="primary" @click="saveConfig"
              >保存明细配置</el-button
            >
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="微信专属配置" name="wechatConfig">
        <div class="pane-content">
          <div class="pane-header">
            <h3>微信专属开发配置</h3>
            <span class="desc"
              >微信开票通道专属参数。保存本地后，可同步至宜收宝微信开票配置接口。</span
            >
          </div>

          <el-form
            :model="formData"
            label-width="160px"
            class="form-area"
            style="padding-top: 20px"
          >
            <el-form-item label="插卡服务号AppID:">
              <el-input
                v-model="formData.wx_card_appid"
                placeholder="wx_card_appid"
                clearable
              />
            </el-form-item>
            <el-form-item label="展示开发票入口:">
              <el-switch
                v-model="formData.wx_show_fapiao_cell"
                :active-value="1"
                :inactive-value="0"
                active-text="展示"
                inactive-text="隐藏"
              />
            </el-form-item>
            <el-form-item label="支持电子专票申请:">
              <el-switch
                v-model="formData.wx_support_vat_fapiao"
                :active-value="1"
                :inactive-value="0"
                active-text="支持"
                inactive-text="不支持"
              />
            </el-form-item>
            <el-form-item label="微信开票回调地址:">
              <el-input
                v-model="formData.wx_callback_url"
                placeholder="wx_callback_url"
                clearable
              />
            </el-form-item>
          </el-form>

          <div
            class="pane-footer"
            style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
          >
            <div>
              <el-button @click="saveConfig">同步至发票基础配置</el-button>
              <el-button type="success" @click="syncWxConfig"
                >同步至微信开发配置</el-button
              >
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="税号资源查询" name="quota">
        <div class="pane-content">
          <div class="pane-header">
            <h3>宜收宝税号资源余额</h3>
            <span class="desc">查询当前商户所属服务商的税号可用资源余额。</span>
          </div>

          <div class="form-area" style="padding-top: 20px">
            <div v-if="quotaResult" class="quota-cards">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card
                    shadow="hover"
                    style="text-align: center; border-color: #67c23a"
                  >
                    <div style="color: #909399; font-size: 14px">
                      可用税号数量
                    </div>
                    <div
                      style="
                        color: #67c23a;
                        font-size: 36px;
                        font-weight: bold;
                        margin-top: 10px;
                      "
                    >
                      {{ quotaResult.usableNum }}
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover" style="text-align: center">
                    <div style="color: #909399; font-size: 14px">
                      已开通数量
                    </div>
                    <div
                      style="
                        color: #409eff;
                        font-size: 36px;
                        font-weight: bold;
                        margin-top: 10px;
                      "
                    >
                      {{ quotaResult.openedNum }}
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top: 20px">
                <el-col :span="12">
                  <el-card shadow="hover" style="text-align: center">
                    <div style="color: #909399; font-size: 14px">
                      已冻结数量
                    </div>
                    <div
                      style="
                        color: #e6a23c;
                        font-size: 24px;
                        font-weight: bold;
                        margin-top: 10px;
                      "
                    >
                      {{ quotaResult.frozenNum }}
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover" style="text-align: center">
                    <div style="color: #909399; font-size: 14px">服务商 ID</div>
                    <div
                      style="
                        font-size: 20px;
                        font-weight: bold;
                        margin-top: 15px;
                      "
                    >
                      {{ quotaResult.agentId }}
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>

            <el-empty v-else description="暂无查询数据，请点击下方按钮查询" />
          </div>

          <div class="pane-footer">
            <el-button type="primary" @click="fetchQuota"
              >查询税号资源余额</el-button
            >
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, defineExpose } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

const { proxy } = getCurrentInstance();

const visible = ref(false);
const activeTab = ref("baseConfig");
const loading = ref(false);
const currentMerchantId = ref(null);

const quotaResult = ref(null);

// 初始表单数据结构
const initFormData = () => ({
  merchant_id: null,
  enabled: 0,
  auto_invoice: 0,
  channel: 1,
  service_agent_no: "",
  tax_no: "",
  sub_mchid: "",
  product_id: "",
  invoice_scene: "",
  remark: "",
  wx_card_appid: "",
  wx_show_fapiao_cell: 0,
  wx_support_vat_fapiao: 0,
  wx_callback_url: "",
  invoice_items: [],
});
const formData = reactive(initFormData());

const resetData = () => {
  Object.assign(formData, initFormData());
  quotaResult.value = null;
  activeTab.value = "baseConfig";
};

// ============== 暴露给父组件的方法 ==============
const open = (row) => {
  currentMerchantId.value = row.id;
  formData.merchant_id = row.id;
  visible.value = true;
  fetchConfig();
};
defineExpose({ open });

// ============== API 3.1: 查询配置 ==============
const fetchConfig = () => {
  loading.value = true;
  proxy.$api.yishoubaoInvoice
    .getConfig({ merchant_id: currentMerchantId.value })
    .then((res) => {
      if (res.status === 200 && res.data) {
        if (res.data.data.config) {
          Object.assign(formData, res.data.data.config);
          if (!formData.invoice_items) formData.invoice_items = [];

          formData.invoice_items.forEach((item, idx) => {
            item.serialNo = idx + 1;
            // 兼容已有数据：如果后端未下发 itemSpec，则给一个默认空串
            if (item.itemSpec === undefined) item.itemSpec = "";
            if (item.terminal_id === undefined) item.terminal_id = "";
          });
        }
      }
    })
    .catch(() => ElMessage.error("查询配置失败"))
    .finally(() => (loading.value = false));
};

// ============== API 3.2: 保存配置 ==============
const saveConfig = () => {
  loading.value = true;
  proxy.$api.yishoubaoInvoice
    .saveConfig(formData)
    .then((res) => {
      if (res.status === 200 || res.success) {
        ElMessage.success("配置保存成功");
        fetchConfig(); // 刷新解析态数据
      } else {
        ElMessage.error(res.message || "保存失败");
      }
    })
    .catch(() => ElMessage.error("保存失败"))
    .finally(() => (loading.value = false));
};

// ============== API 3.3: 查询资源余额 ==============
const fetchQuota = () => {
  loading.value = true;
  proxy.$api.yishoubaoInvoice
    .queryQuota({ merchant_id: currentMerchantId.value })
    .then((res) => {
      if (res.status === 200 && res.data) {
        quotaResult.value = res.data.data || res.data;
        ElMessage.success("资源余额查询成功");
      }
    })
    .catch(() => ElMessage.error("查询资源余额失败"))
    .finally(() => (loading.value = false));
};

// ============== API 3.5: 同步微信配置 ==============
const syncWxConfig = () => {
  ElMessageBox.confirm(
    "这将会把当前本地保存的微信配置参数同步到宜收宝上游，是否继续？",
    "同步确认",
    {
      confirmButtonText: "确定同步",
      cancelButtonText: "取消",
      type: "warning",
    },
  )
    .then(() => {
      loading.value = true;
      proxy.$api.yishoubaoInvoice
        .syncWxConfig({ merchant_id: currentMerchantId.value })
        .then((res) => {
          if (res.status === 200) {
            ElMessage.success("微信开发配置同步成功！");
          } else {
            ElMessage.error("同步失败");
          }
        })
        .catch(() => ElMessage.error("同步请求异常"))
        .finally(() => (loading.value = false));
    })
    .catch(() => {});
};

// ============ 杂项：发票明细增删 ============
const addInvoiceItem = () => {
  if (formData.invoice_items.length >= 8) return;
  const newIndex = formData.invoice_items.length + 1;
  formData.invoice_items.push({
    serialNo: newIndex,
    itemNum: newIndex,
    taxCode: "",
    itemTaxRate: "",
    itemName: "",
    itemSpec: "", // 新增：初始化规格型号为空字符串
    itemUnit: "",
    invoiceAmount: "",
    invoiceLineProperty: "NORMAL_LINE",
    terminal_id: "",
  });
};
const removeInvoiceItem = (index) => {
  formData.invoice_items.splice(index, 1);
  formData.invoice_items.forEach((item, idx) => {
    item.serialNo = idx + 1;
    item.itemNum = idx + 1;
  });
};
</script>

<style scoped lang="less">
/* 每个 Tab 面板的整体布局 */
.pane-content {
  display: flex;
  flex-direction: column;
  height: 550px;
  padding: 0 20px;
  box-sizing: border-box;

  .pane-header {
    flex: 0 0 auto;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;

    h3 {
      margin: 0 0 5px 0;
      color: #303133;
      font-size: 18px;
    }

    .desc {
      font-size: 13px;
      color: #909399;
    }
  }

  .form-area {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 15px 10px 15px 0;

    /* 隐藏滚动条但保留滚动效果 (美观) */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #dcdfe6;
      border-radius: 3px;
    }
  }

  .pane-footer {
    flex: 0 0 auto;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }
}

/* Deep 穿透左侧 Tabs 样式，让其看起来像导航菜单 */
::v-deep .el-tabs--left .el-tabs__header.is-left {
  width: 150px;
  margin-right: 0;
  border-right: 1px solid #ebeef5;
  background-color: #fafafa;
}

::v-deep .el-tabs__item {
  text-align: left !important;
  padding-left: 20px !important;
  font-size: 14px;
}

::v-deep .el-tabs__item.is-active {
  background-color: #ecf5ff;
  border-right: 2px solid #409eff;
}
</style>
